import { render, staticRenderFns } from "./NsBifrostButton.vue?vue&type=template&id=537ad374&scoped=true&"
import script from "./NsBifrostButton.vue?vue&type=script&lang=js&"
export * from "./NsBifrostButton.vue?vue&type=script&lang=js&"
import style0 from "./NsBifrostButton.vue?vue&type=style&index=0&id=537ad374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537ad374",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/gitlab-runner-data/builds/ns-am/product/apps/catalog/components/Button.vue').default})
